import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { Maybe } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export interface LTLEquipmentOption {
  label: string;
  value: string;
  flag?: Maybe<string>;
}

export type GetLTLEquipmentResponse = {
  equipment: LTLEquipmentOption[];
};

export async function getLTLEquipment(
  integrationId: number,
  isForceRefresh = false
): Promise<Result<GetLTLEquipmentResponse, ApiError>> {
  try {
    const response = await axios.get<GetLTLEquipmentResponse>(
      '/quote/ltl/equipment',
      {
        params: {
          integrationId,
          isForceRefresh,
        },
      }
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLTLEquipment' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get LTL equipment' });
    }

    return err({
      message: error.response?.data?.message || 'Failed to get LTL equipment',
    });
  }
}
